"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPanStatusColor = getPanStatusColor;
const PAN_VERIFIED_COLOR = { textColor: '#00801A', bgColor: '#F1FFF4' };
const PAN_NOT_VERIFIED_THRESHOLDS = [
    { maxCredits: 3000000, color: { textColor: '#494949', bgColor: 'rgba(0, 0, 0, 0.1)' } },
    { maxCredits: 4000000, color: { textColor: '#805600', bgColor: '#FFEEDB' } },
    { maxCredits: 4500000, color: { textColor: '#BA1A1A', bgColor: '#FFEDEA' } },
    { maxCredits: Infinity, color: { textColor: '#FFEDEA', bgColor: '#DE3730' } },
];
/**
 * Returns the text and background color for a PAN status badge
 * based on the worker's PAN verification and total earned credits.
 */
function getPanStatusColor({ panStatus, totalEarnedCredits }) {
    if (panStatus === 'Verified')
        return PAN_VERIFIED_COLOR;
    for (const tier of PAN_NOT_VERIFIED_THRESHOLDS) {
        if (totalEarnedCredits < tier.maxCredits)
            return tier.color;
    }
    return PAN_NOT_VERIFIED_THRESHOLDS[PAN_NOT_VERIFIED_THRESHOLDS.length - 1].color;
}
//# sourceMappingURL=PANStatus.js.map